import { getters } from '/@/modules/core/app/helpers/store';
import { RouteListConfig } from '/@/modules/core/app/helpers/RouteListConfig';

export class AdminRouteConfig extends RouteListConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    return getters.auth.getUser().permission.canAccessAdminRoutes;
  }
}
